import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Globals } from '../globals';
import { environment } from '../../environments/environment'
 
//This class will check for lab availablity, if not redirects lab page.
// Author: Naveen
@Injectable({providedIn: 'root'})
export class LabGuard  {
     
    constructor(private router: Router, private _globals: Globals) { }
 
    //Routes to lab page if it is not available
    canActivate(route: ActivatedRouteSnapshot) {
        let selectedLab = JSON.parse(localStorage.getItem('lab'))
        
        if (!selectedLab) {
            this.router.navigate(['/lab']);
            console.log("Routing to lab screen ")
            return false;
        }else{
            if (!environment.AZURE_LOGIN_NEEDED) {
                return true
            }
            console.log("Lab guard: "+selectedLab.label)
            console.log("Routing to App screen ")

            let token = JSON.parse(localStorage.getItem('token'))
            if (token && token.access_token) {
                return true
            } else {
                this.router.navigate(['/'])
                return false
            }

        }
        
    }
}